import { useRef, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './ProjectsSection.module.scss'
import SectionTitle from '../SectionTitle/SectionTitle'

const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function ProjectsSection() {
	const swiperRef = useRef(null)
	const prevRef = useRef(null)
	const nextRef = useRef(null)
	const [projects, setProjects] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)
	const [isVideoOpen, setIsVideoOpen] = useState(false)
	const [currentVideo, setCurrentVideo] = useState('')

	useEffect(() => {
		fetch(`${API_PREFIX}/api/sections/get/projects/list`)
			.then((res) => {
				if (!res.ok) throw new Error('Ошибка загрузки проектов')
				return res.json()
			})
			.then((data) => {
				setProjects(data.projects ?? [])
				setLoading(false)
			})
			.catch((e) => {
				setError(e.message)
				setLoading(false)
			})
	}, [])

	useEffect(() => {
		if (isVideoOpen) {
			const scrollY = window.scrollY
			document.body.style.position = 'fixed'
			document.body.style.top = `-${scrollY}px`
			document.body.style.width = '100%'
		} else {
			const scrollY = document.body.style.top
			document.body.style.position = ''
			document.body.style.top = ''
			if (scrollY) window.scrollTo(0, parseInt(scrollY) * -1)
		}
	}, [isVideoOpen])

	const isTouchDevice = () =>
		'ontouchstart' in window || navigator.maxTouchPoints > 0

	const handleButtonEffect = (e) => {
		if (!e.currentTarget) return
		e.currentTarget.classList.add('active')
		setTimeout(() => {
			e.currentTarget?.classList.remove('active')
		}, 300)
	}

	useEffect(() => {
		if (swiperRef.current && swiperRef.current.swiper) {
			const swiper = swiperRef.current.swiper
			swiper.params.navigation.prevEl = prevRef.current
			swiper.params.navigation.nextEl = nextRef.current
			swiper.navigation.destroy()
			swiper.navigation.init()
			swiper.navigation.update()
		}
	}, [projects])

	const openVideo = (url) => {
		setCurrentVideo(url)
		setIsVideoOpen(true)
	}

	const closeVideo = () => {
		setIsVideoOpen(false)
		setCurrentVideo('')
	}

	const getVideoSrc = (url) =>
		url.startsWith('/') ? `${API_PREFIX}${url}` : url

	return (
		<section id='achievements' className={styles.projects}>
			<div className={`container ${styles.projects__container}`}>
				<SectionTitle>Проекты наших учеников</SectionTitle>
				{loading && <div>Загрузка...</div>}
				{error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}
				{!loading && !error && (
					<Swiper
						ref={swiperRef}
						modules={[Navigation]}
						spaceBetween={50}
						grabCursor
						slidesPerView={1}
						loop
						navigation={{
							prevEl: prevRef.current,
							nextEl: nextRef.current,
						}}
						onSwiper={(swiper) => {
							swiper.params.navigation.prevEl = prevRef.current
							swiper.params.navigation.nextEl = nextRef.current
							swiper.navigation.init()
							swiper.navigation.update()
						}}
					>
						{projects.map((project, index) => (
							<SwiperSlide key={project.id ?? index}>
								<div className={styles.projectSlide}>
									<div
										className={styles.projectVideoThumb}
										style={{ cursor: project.videoUrl ? 'pointer' : 'default' }}
										onClick={() =>
											project.videoUrl && openVideo(project.videoUrl)
										}
									>
										<img
											src={
												project.videoThumb.startsWith('/')
													? `${API_PREFIX}${project.videoThumb}`
													: project.videoThumb
											}
											alt={project.name}
											loading='lazy'
										/>
										{project.videoUrl && (
											<div className={styles.playButton}>
												<img src='/img/icons/play.svg' alt='Play' />
											</div>
										)}
									</div>
									<div className={styles.projectInfo}>
										<span className={styles.projectCategory}>
											{project.category}
										</span>
										<h3 className={styles.projectName}>{project.name}</h3>
										<p className={styles.projectLessons}>
											Пройдено уроков: {project.lessons}
										</p>
										<p className={styles.projectDescription}>
											{project.description}
										</p>
									</div>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				)}

				<div className={styles.projectsNavigation}>
					<div
						className={styles.projectsSliderButtonPrev}
						ref={prevRef}
						onClick={() => swiperRef.current?.swiper.slidePrev()}
					>
						<div
							className={styles.btnContainer}
							{...(isTouchDevice()
								? { onTouchStart: handleButtonEffect }
								: { onMouseDown: handleButtonEffect })}
						>
							<div className={styles.consultBtn}>
								<img src='/img/slider/arrow-left.svg' alt='Предыдущий' />
							</div>
						</div>
					</div>

					<div
						className={styles.projectsSliderButtonNext}
						ref={nextRef}
						onClick={() => swiperRef.current?.swiper.slideNext()}
					>
						<div
							className={styles.btnContainer}
							{...(isTouchDevice()
								? { onTouchStart: handleButtonEffect }
								: { onMouseDown: handleButtonEffect })}
						>
							<div className={styles.consultBtn}>
								<img src='/img/slider/arrow-right.svg' alt='Следующий' />
							</div>
						</div>
					</div>
				</div>
			</div>

			{isVideoOpen && currentVideo && (
				<div className={styles.videoPopup} onClick={closeVideo}>
					<div
						className={styles.videoPopupContent}
						onClick={(e) => e.stopPropagation()}
					>
						<button className={styles.videoPopupClose} onClick={closeVideo}>
							×
						</button>
						<video
							src={getVideoSrc(currentVideo)}
							controls
							autoPlay
							width='100%'
							height='100%'
							style={{
								maxWidth: 900,
								maxHeight: 520,
								background: '#000',
								display: 'block',
								margin: '0 auto',
							}}
						>
							Ваш браузер не поддерживает видео.
						</video>
					</div>
				</div>
			)}
		</section>
	)
}
